export type TQueryKeyType = 'array' | 'scalar';
export type TQueryKeyConfig = { key: string; type: TQueryKeyType };

const TYPE_SECTION_PHD = 'portfolio-change-dynamics';
const TYPE_SECTION_DQSIE = 'dynamics-quantity-status-inclusion-exclusion';
const TYPE_SECTION_NJC = 'number-jobs-created';
const TYPE_SECTION_SGP = 'share-green-projects';
const TYPE_SECTION_DOP = 'distribution-of-projects';

const DEFAULT_DYNAMIC = 1;

const DONUT_PROJECTS_MPK_PORTFOLIO_NAME = ['Реализовано проектов', 'Не реализовано проектов'];

const DONUT_PROJECTS_MPK_PORTFOLIO_COLOR = ['#0078C8', '#D1D5DB'];

const DONUT_PROJECTS_MPK_PORTFOLIO_INFO = [
  { id: 'implemented-projects', name: 'Реализовано проектов', color: '#0078C8', count: 0 },
  { id: 'total-projects', name: 'Всего проектов', color: '#D1D5DB', count: 0 },
];

const NAVIGATION_TYPE = {
  SIDEBAR: 'SIDEBAR',
  BACK: 'BACK',
  BUTTON: 'BUTTON',
} as const;

const PAGE_KEY = {
  LIST: 'LIST',
  MAP: 'MAP',
  STATISTICS: 'STATISTICS',
} as const;

const FILTER_STORAGE_KEY = {
  LIST: 'mpk_projects_list_filter',
  MAP: 'mpk_projects_map_filter',
} as const;

const MPK_PROJECT_ROUTE_PATHS = {
  LIST: '/mpkProjects/list',
  MAP: '/mpkProjects/map',
  STATISTICS: '/mpkProjects/statistics',
} as const;

const FILTER_MAP = {
  countryIds: 'countryId',
  purposeIds: 'purposeId',
  industryIds: 'industryId',
  statusIds: 'statusId',
} as const;

// Стратегии парсинга query-параметров
export const QUERY_KEY_TYPE: { ARRAY: TQueryKeyType; SCALAR: TQueryKeyType } = {
  ARRAY: 'array',
  SCALAR: 'scalar',
};

/**
 * Служебные query-маркеры навигации - используются для управления логикой восстановления фильтров.
 * FILTER_RESET - принудительный сброс: применить только то, что явно передано в URL
 * SAVED - рефреш-снимок: в localStorage лежит полный фильтр, включая поля без URL-представления
 *   (даты, суммы, участники и пр). При перезагрузке приложения на странице предпочитаем localStorage вместо неполного URL
 */
export const URL_MARKERS = {
  FILTER_RESET: '_filterReset',
  SAVED: '_saved',
} as const;

// Какие ключи фильтров сохранять в URL для каждой страницы и стратегия парсинга
const URL_FILTER_KEYS: Record<string, TQueryKeyConfig[]> = {
  LIST: [
    { key: 'countryIds', type: QUERY_KEY_TYPE.ARRAY },
    { key: 'industryIds', type: QUERY_KEY_TYPE.ARRAY },
    { key: 'statusIds', type: QUERY_KEY_TYPE.ARRAY },
    { key: 'purposeIds', type: QUERY_KEY_TYPE.ARRAY },
    { key: 'mpkComissionId', type: QUERY_KEY_TYPE.SCALAR },
  ],
  MAP: [{ key: 'countryIds', type: QUERY_KEY_TYPE.ARRAY }],
  STATISTICS: [{ key: 'countryIds', type: QUERY_KEY_TYPE.ARRAY }],
};

const FILTER_CONFIGS = [
  { prop: 'countryId', key: 'countryIds', param: 'countryId' },
  { prop: 'purposeId', key: 'purposeIds', param: 'purposeId' },
  { prop: 'industryId', key: 'industryIds', param: 'industryId' },
  { prop: 'statusId', key: 'statusIds', param: 'statusId' },
];

const NUMBER_OF_TEMPORARY_JOBS = 'Количество временных рабочих мест';
const NUMBER_OF_PERMANENT_JOBS = 'Количество постоянных рабочих мест';

const COLORS = ['#DC3545', '#0078C8', '#FFD966', '#28A745', '#7A61FF', '#43EDDA', '#8f4800', '#008f7e', '#113806'];

const CURRENT_PERIOD = 'Текущий период';
const PREVIOUS_PERIOD = 'Предыдущий период';

const MPK_PROJECT_STATUS_ID = {
  EXPLOITATION: 1,
  INVEST: 2,
  PRED_INVEST: 3,
  STOPPED: 4,
} as const;

const JOINT_PROJECT_MODE = {
  ALL: 1,
  ONLY_JOINT: 2,
  NO_JOINT: 3,
} as const;

const JOINT_PROJECT_MODE_OPTIONS = [
  { id: JOINT_PROJECT_MODE.ALL, text: 'Все проекты' },
  { id: JOINT_PROJECT_MODE.ONLY_JOINT, text: 'Только совместные' },
  { id: JOINT_PROJECT_MODE.NO_JOINT, text: 'Без совместных' },
];

const FileFormats = [
  { id: 1, text: 'Файл Excel (XLSX)' },
  { id: 2, text: 'Файл Word (DOCX)' },
  { id: 3, text: 'Презентация PowerPoint (PPTX)' },
  { id: 4, text: 'Файл PDF (PDF)' },
];

const INCLUSION_MODE_OPTIONS = [
  { id: 1, text: 'Включенные проекты' },
  { id: 2, text: 'Исключенные проекты' },
];

export default {
  NAVIGATION_TYPE,
  PAGE_KEY,
  FILTER_STORAGE_KEY,
  INCLUSION_MODE_OPTIONS,
  MPK_PROJECT_ROUTE_PATHS,
  TYPE_SECTION_PHD,
  TYPE_SECTION_DQSIE,
  TYPE_SECTION_NJC,
  TYPE_SECTION_SGP,
  TYPE_SECTION_DOP,
  DEFAULT_DYNAMIC,
  DONUT_PROJECTS_MPK_PORTFOLIO_NAME,
  DONUT_PROJECTS_MPK_PORTFOLIO_COLOR,
  DONUT_PROJECTS_MPK_PORTFOLIO_INFO,
  NUMBER_OF_TEMPORARY_JOBS,
  NUMBER_OF_PERMANENT_JOBS,
  COLORS,
  CURRENT_PERIOD,
  PREVIOUS_PERIOD,
  MPK_PROJECT_STATUS_ID,
  JOINT_PROJECT_MODE,
  JOINT_PROJECT_MODE_OPTIONS,
  FileFormats,
  FILTER_MAP,
  FILTER_CONFIGS,
  URL_FILTER_KEYS,
  QUERY_KEY_TYPE,
};
